import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const FederatedUserLoginError = () => (
  <BaseErrorDisplay
    title="There is a problem accessing this account."
    subtitle="USER LOGIN ERROR"
    description="There's a problem that has prevented access to this account. Please try again later."
    imgSrc={infoSvg}
  />
)
